import { render, staticRenderFns } from "./PageGoodsAdd.vue?vue&type=template&id=109a2076&scoped=true"
import script from "./PageGoodsAdd.vue?vue&type=script&lang=js"
export * from "./PageGoodsAdd.vue?vue&type=script&lang=js"
import style0 from "./PageGoodsAdd.vue?vue&type=style&index=0&id=109a2076&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "109a2076",
  null
  
)

export default component.exports